module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-4-39d43bfdf934247903c82583430f1148.png";